import api from "../../config/http-common";

const create = (payload) => {
  return api.unsecuredAxios().post("/onboard/user/authorize", payload);
};

const getCompanies = () => {
  return api
    .switchCompanyAxios()
    .get(
      `/onboard/company?pageNumber=1&pageSize=1000&applicationId=` +
        localStorage.getItem("applicationId"),
    );
};

const switchCompanies = () => {
  return api
    .securedAxios()
    .get(
      `/onboard/company?pageNumber=1&pageSize=1000&applicationId=` +
        localStorage.getItem("applicationId"),
    );
};

const switchCompany = (payload) => {
  return api.switchCompanyAxios().put("/onboard/company", payload);
};

const webSwitchCompanyAPI = (payload) => {
  return api.switchCompanyAxios().put("/onboard/api/v5/switch/token", payload);
};

const selectCompany = (payload) => {
  return api.securedAxios().put("/onboard/company", payload);
};

const revoke = () => {
  return api.securedAxios().get("/api/v3/token_revoke?fcmToken=");
};

const createUser = (payload) => {
  return api.unsecuredAxios().post("/onboard/user", payload);
};

const refreshToken = (payload) => {
  return api.unsecuredAxios().post("/api/v2.0/refresh_token", payload);
};

const LoginService = {
  create,
  revoke,
  getCompanies,
  switchCompany,
  refreshToken,
  createUser,
  switchCompanies,
  selectCompany,
  webSwitchCompanyAPI,
};

export default LoginService;
